// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.CreatePlaidLinkTokenWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CreatePlaidLinkTokenWebApiRequestDto, CreatePlaidLinkTokenWebApiResponseDto } from '../..';

export const CreatePlaidLinkTokenWebApiHandler_createPlaidLinkToken_Path = '/api/web/v1/createPlaidLinkToken';

/**
 * create plaid link token
 */
export const CreatePlaidLinkTokenWebApiHandler_createPlaidLinkToken = (
  postData: CreatePlaidLinkTokenWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreatePlaidLinkTokenWebApiRequestDto, CreatePlaidLinkTokenWebApiResponseDto>(
    {
      endpoint: CreatePlaidLinkTokenWebApiHandler_createPlaidLinkToken_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
